import moment from "moment";
import label from "../components/formInputs/Label";
import { fullName } from "../pages/client/ClientProfile/component/tabs/ClientProfileTab";
import { dateUtils } from ".";
import {agentTypeDropDown, getImoNameByValue, SITE_URL} from "../constants";
import { el } from "date-fns/locale";
import { AccountStatus, AccountStatusArr, AccountType } from "../model";
import {boolToYesNo, joinAsFullName, maskPhoneNumber} from "./commonUtils";
import {extracted} from "../components/group/ParticipantList";
import {asMMDDYYYY} from "./dateUtils";
 
const getAgentTypeText = (account) => {
    const agentType = agentTypeDropDown.find(x => x.value === account["agent.agentType"]);
    return agentType && agentType.text
}
  const getLogin =  (lastLogin) =>{
     return  lastLogin ? dateUtils.asDbDateFormat(lastLogin) : 'Never Logged In';
  }
export const tablesCsvMapping = (filter: number, callingFrom: string): { label: string, value: any }[] | undefined => {
   const checkNull = (value) => value || "";
    switch (filter){
    case 5: return [
        {
            label: "Client Name",
            value: (row: any) => row.firstName + ' ' + row.lastName
        },
        {
            label: "Client Email",
            value: "email"
        },
        {
            label: "Agent Name",
            value: (row: any) => row["client.clientPolicies.agent.user.name"] || ''
        },
        {
            label: "Tranche #",
            value: (row: any) => row["client.clientPolicies.tranche.trancheNumber"] || ''
        },
        {
            label: "IMO",
            value: (row: any) => row["client.clientPolicies.imo.groupName"] || ''
        },
        {
            label: "Region",
            value: (row: any) => row["client.clientPolicies.imo.region"] || ''
        },
        {
            label: "Ilia Product Type",
            value: (row: any) => row["client.clientPolicies.strategy.displayName"] || ''
        },
        {
            label: "Carrier",
            value: (row: any) => row["client.clientPolicies.carrier.carrierName"] || '',
        },
        {
            label: "Status",
            value: (row: any) => AccountStatusArr[row.inviteStatus || 0],
        },
        {
            label: "Date Created",
            value: (row: any) => row.createdAt ? moment(row.createdAt).format("MM-DD-YYYY") : ''
        },
        {
            label: "Last Login",
            value: (row: any) => getLogin(row.lastLogin),
        },
    ];
    case 10: return [
        {
            label: "Group Name",
            value: (row: any) => row["groupLink.groupName"] || '',
        },
        {
            label: "Phone Number",
            value: (row: any) => row["phoneNumber"] || '',
        },
        {
            label: "First Name",
            value: (row: any) => row["firstName"] || '',
        },
        {
            label: "Last Name",
            value: (row: any) => row["lastName"] || '',
        },
        {
            label: "Email",
            value: (row: any) => row["email"] || '',
        },
    ];
    case  2: return [
        {
            label: "Name",
            value: (row: any) => fullName(row) || '',
        },
        {
            label: "Email",
            value: (row: any) => row.email || '',
        },
        {
            label: "Type",
            value: (row: any) => row["admin.adminType"] || '',
        },
        {
            label: "Last Login",
            value: (row: any) => row.lastLogin || "",
        },
        {
            label: "Created At",
            value: (row: any) => dateUtils.asDbDateFormat(row["createdAt"]) || '',
        },
    ];
    case 4: return [
            {
                label: "First Name",
                value: (row: any) => row["firstName"] || '',
            },
            {
                label: "Last Name",
                value: (row: any) => row["lastName"] || '',
            },
            {
                label: "Email",
                value: (row: any) => row["email"] || '',
            },
            {
                label: "Agent Type",
                value: (row: any) => getAgentTypeText(row) || '',
            },
            {
                label: "IMO's",
                value: (row: any) => row["agent.agentImos.imo.groupName"] || '',
            },
            {
                label: "Primary Carrier",
                value: (row: any) => row["agent.agentImos.agentImoCarriers.carrier.carrierName"] || '',
            },
            {
                label: "# of Participants",
                value: (row: any) => row["agent.participants"] || '',
            },
            {
                label: "Invite Status",
                value: (row: any) => AccountStatusArr[row.inviteStatus || 0],
            },
            {
                label: "Created At",
                value: (row: any) => dateUtils.asDbDateFormat(row.createdAt) || "",
            },
            {
                label: "Last Login",
                value: (row: any) => getLogin(row.lastLogin),
            },
        ];
    case 16: const arr = [
            {
                label: "First Name",
                value: (row: any) => row["firstName"] || '',
            },
            {
                label: "Last Name",
                value: (row: any) => row["lastName"] || '',
            },
            {
                label: "Giftor Name",
                value: (row: any) => `${checkNull(row["user.parentDetails.firstName"])} ${checkNull(row["user.parentDetails.lastName"])}` || '',
            },
            {
                label: "Email",
                value: (row: any) => row["email"] || '',
            },
           
            {
                label: "Participant Type",
                value: (row: any) => row.participantType || '',
            },
            {
                label: "Tranche",
                value: (row: any) => row["user.client.clientPolicies.tranche.trancheNumber"]
            }
        
        ];
            if (callingFrom == "accountList"){
                append(arr,[
                    {
                        label: "Agent Name",
                        value: (row: any) => row["agent.user.name"] || '',
                    },
                    {
                        label: "IMO",
                        value: (row: any) => row["imo.groupName"] || '',
                    },
                    {
                        label: "Region",
                        value: (row: any) => row["imo.region"] || '',
                    },
                ])
            }
            append(arr, [
                {
                    label: "ilia Product Type",
                    value: (row: any) => row["strategy.strategyName"] ? row["strategy.strategyName"] : row["strategyName"],
                },
                {
                    label: "Carrier",
                    value: (row: any) => row["carrier.carrierName"] || '',
                },
                {
                    label: "Status",
                    value: (row: any) => AccountStatusArr[row['user.inviteStatus'] || 0],
                },
                {
                    label: "Date Created",
                    value: (row: any) => row['createdAt']
                },
            ])

        return arr;

    case 14: return [
            {
                label: "Client Name",
                value: (row: any) => row['clientListName']
            },
            {
                label: "Participants",
                value: (row: any) => row['participants']
            },
            {
                label: "Agent",
                value: (account: any) => account.agent && account.agent.user && account.agent.user.name
            },
            {
                label: "IMO",
                value: (account: any) => account.agent && account.agent.imo && account.agent.imo.groupName
            },
            {
                label: "Region",
                value: (account: any) => account.agent && account.agent.imo && account.agent.imo.region
            },
            {
                label: "Date Created",
                value: (account: any) => dateUtils.asDbDateFormat(account.createdAt)
            },

        ];
    case 8: return [
            {
                label: "Group Name" ,
                value: (account: any) => account["company.companyName"]
            },
            {
                label: "Group Admin",
                value: (account: any) => account.firstName + " " + account.lastName
            },
            {
                label: "Group Type",
                value: (account: any) => account["company.groupType"] || "NA"
            },
            {
                label: "ilia Product Type",
                value: (account: any) => account["company.strategies.name"],
            },
            {
                label: "Accounts Created",
                value: (account: any) => account["company.accountCreated"],
            },
            {
                label: "Total Enrollments",
                value: (account: any) => account["company.enrollmentCount"],
            },
            {
                label: "Date Created",
                value: (account: any) => dateUtils.asDbDateFormat(account.createdAt)
            },
    ]
    //banks-list
    case 13: return [
        {
            label: "Bank Name",
            value: (account: any) => account["bank.bankName"]
        },
        {
            label: "Primary Contact",
            value: (account: any) => maskPhoneNumber(account["phoneNumber"])
        },
        {
            label: "First name",
            value: (account: any) => account.firstName,
        },
        {
            label: "Last Name",
            value: (account: any) => account.lastName,
        },
        {
            label: "Email",
            value: (account: any) => account.email,
        },
    ]
    // imo-list
    case 3: return [
        {
            label: "IMO Company Name",
            value: (account: any) => account["imo.groupName"]
        },
        {
            label: "IMO Type",
            value: (account: any) => getImoNameByValue(account["imo.imoClass"])
        },
        {
            label: "IMO Region",
            value: (account: any) => account["imo.region"] || "Un-Assigned",
        },
        {
            label: "Office Number",
            value: (account: any) => maskPhoneNumber(account["imo.officeNumber"]),
        },
        {
            label: "First Name",
            value: (account: any) => account.firstName,
        },
        {
            label: "Last Name",
            value: (account: any) => account.lastName,
        },
        {
            label: "Email",
            value: (account: any) => account.email,
        },
        {
            label: "Carrier(s)",
            value: (account: any) => account["imo.carrierName"],
        },
        {
            label: "# of Agents",
            value: (account: any) => account["imo.agentCount"] || 0,
        },
        {
            label: "Currently Enrolling",
            value: (account: any) => account["imo.currentlyEnrolling"] || 0,
        },
        {
            label: "Paid Cases",
            value: (account: any) => account["imo.paidCases"] || 0,
        },
        {
            label: "Status",
            value: (account: any) => (account.role === 5 || account.role === 6) && account.subscribe_marketing === 0 && account.subscribe_advisors === 0 ? 'Unsubscribed' : AccountStatusArr[account.inviteStatus || 0],
        }, 
        {
            label: "Date Created",
            value: (account: any) => dateUtils.asDbDateFormat(account.createdAt),
        },
        {
            label: "Last Login",
            value: (account: any) => account.lastLogin ? dateUtils.asDbDateFormat(account.lastLogin) : 'Never Logged In',
        },
    ]
    case 18: return [
        {
            label: "Aggregator Name",
            value: (account: any) => account["aggregator.aggregatorName"]
        },
        {
            label: "Primary Contact",
            value: (account: any) => account["phoneNumber"]
        },
        {
            label: "First Name",
            value: (account: any) => account.firstName,
        },
        {
            label: "Last Name",
            value: (account: any) => account.lastName,
        },
        {
            label: "Email",
            value: (account: any) => account.email,
        },
    ]
        case 12: return [
            {
                label: "Trustee Name",
                value: (account: any) => account["trustee.trusteeName"]
            },
            {
                label: "Primary Contact",
                value: (account: any) => maskPhoneNumber(account["phoneNumber"])
            },
            {
                label: "First Name",
                value: (account: any) => account.firstName,
            },
            {
                label: "Last Name",
                value: (account: any) => account.lastName,
            },
            {
                label: "Email",
                value: (account: any) => account.email,
            },
        ]
    case 7: return [
        {
            label: "Carrier Name",
            value: (account: any) => account["carrier.carrierName"]
        },
        {
            label: "Primary Contact",
            value: (account: any) => maskPhoneNumber(account["carrier.carrierPhone"])
        },
        {
            label: "First Name",
            value: (account: any) => account.firstName,
        },
        {
            label: "Last Name",
            value: (account: any) => account.lastName,
        },
        {
            label: "Email",
            value: (account: any) => account.email,
        },
        {
            label: "Documents",
            value: (account: any) => "--",
        },
        {
            label: "Status",
            value: (account: any) => (account.role === 5 || account.role === 6) && account.subscribe_marketing === 0 && account.subscribe_advisors === 0 ? 'Unsubscribed' : AccountStatusArr[account.inviteStatus || 0],
        },
        {
            label: "Date Created",
            value: (account: any) => dateUtils.asDbDateFormat(account.createdAt),
        },
    ]
    };
}


export const exportCsvCalling = (callingFrom:"imoProfile"|"imoAgentClient"| "trancheManagementWorkFlow"|"trancheRate"| "trancheManagementReview"| "trancheManagementPayment") =>{
    switch (callingFrom){
        case "trancheManagementWorkFlow":
            return [
                {
                    label: "Tranche Number",
                    value: (row: any) => row["trancheNo"] || '',
                },
                {
                    label: "Insured",
                    value: (row: any) => row["clientName"]
                        ? `=HYPERLINK("${SITE_URL}new-client/detail/${row["clientId"]}", "${row["clientName"]}")`
                        : '',
                },
                {
                    label: "Insured Type",
                    value: (row: any) => row["insuredType"] || '',
                },
                {
                    label: "App Type",
                    value: (row: any) => row["appType"] || '',
                },
                {
                    label: "Product Type",
                    value: (row: any) => row["productType"] || '',
                },
                {
                    label: "Participant Status",
                    value: (row: any) => AccountStatus[row["inviteStatus"]] || '',
                },
                {
                    label: "Case Processor",
                    value: (row: any) => row["caseProcessor"] || '',
                },
                {
                    label: "IMO",
                    value: (row: any) => row["groupName"] || '',
                },
                {
                    label: "1035",
                    value: (row: any) =>  boolToYesNo(row.has1035) || '',
                },
                {
                    label: "Policy #",
                    value: (row: any) => row["policyNumber"] || '',
                },
                {
                    label: "Agent",
                    value: (row: any) => row["agentName"] || '',
                },
                {
                    label: "Region",
                    value: (row: any) => row["region"] || '',
                },
                {
                    label: "Case Manager",
                    value: (row: any) => row["caseManager"] || '',
                },

                {
                    label: "Total Premium",
                    value: (row: any) => row["annualPremium"] || '',
                },
                {
                    label: "Target",
                    value: (row: any) => row["targetAmount"] || '',
                },
                {
                    label: "Death Benefit",
                    value: (row: any) => row["initialTotalDeathBenefit"] || '',
                },
                {
                    label: "ID Document",
                      value: (row: any) => {
                      const date = row["documentExpirationDate"];
                      if (!date) return '';
                      return new Date(date) < new Date() ? "Expired" : "Not Expired";
                     }
                },


                {
                    label: "Contribution Frequency",
                    value: (row: any) => row["contributionFrequency"] || '',
                },
                {
                    label: "Contribution Received Date",
                    value: (row: any) => asMMDDYYYY(row.contributionReceivedDate) || '',
                },
                {
                    label: "Contribution Owed",
                    value: (row: any) => row["contributionOwed"] || '',
                },
                {
                    label: "Contribution Amount Received",
                    value: (row: any) => row["contributionReceived"] || '',
                },
                {
                    label: "Employer Owed",
                    value: (row: any) => row["employerOwed"] || '',
                },
                {
                    label: "Employer Received",
                    value: (row: any) => row["employerReceived"] || '',
                },
                {
                    label: "Bank Contribution",
                    value: (row: any) => row["bankContribution"] || '',
                },
                {
                    label: "Participant Status",
                    value: (row: any) => row["processingStatus"] || '',
                },
                {
                    label: "App Signed Date",
                    value: (row: any) => asMMDDYYYY(row.appSignedDate) || '',
                },
                {
                    label: "Trust Signed Date",
                    value: (row: any) => asMMDDYYYY(row.trustSignedDate) || '',
                },
                {
                    label: "Notes",
                    value: (row: any) => (row: any) => row["trustSignedDate"] || '',
                },
            ]
        case "imoProfile":
            return [
                {
                    label: "First Name",
                    value: (row: any) => row["firstName"]
                        ? `=HYPERLINK("${SITE_URL}new-agent/detail/${row["agent.userId"]}", "${row["firstName"]}")`
                        : '',
                },
                {
                    label: "Last Name",
                    value: (row: any) =>  row["lastName"]
                        ? `=HYPERLINK("${SITE_URL}new-agent/detail/${row["agent.userId"]}", "${row["lastName"]}")`
                        : '',
                },
                {
                    label: "Email",
                    value: (row: any) => row["email"] || '',
                },
                {
                    label: "Total Invite",
                    value: (row: any) => row["totalInvites"],
                },
                {
                    label: "Total Link Leads",
                    value: (row: any) => row["totalLinkLeads"],
                },
                {
                    label: "Total Clients",
                    value: (row: any) => row["totalClients"],
                },
                {
                    label: "Total Groups",
                    value: (row: any) => row["totalGroups"],
                },
                {
                    label: "Currently Enrolling",
                    value: (row: any) => row["currentlyEnrolling"],
                },
                {
                    label: "Paid Cases",
                    value: (row: any) => row["paidCases"],
                },
                {
                    label: "Date account created",
                    value: (row: any) => dateUtils.asDbDateFormat(row["agent.createdAt"]),
                },
                {
                    label: "Last Login",
                    value: (row: any) => getLogin(row.lastLogin),
                },
            ];

        case "imoAgentClient":
            return [
                {
                    label: "Client Name",
                    value: (row: any) => joinAsFullName(row)
                        ? `=HYPERLINK("${SITE_URL}new-client/detail/${row.user && row.user.client && row.user.client.id}/${row.user && row.user.client && row.user.client.clientPolicies[0].id}", "${row["firstName"]} ${row["lastName"]}")`
                        : ''
                    ,
                },
                {
                    label: "Client Email",
                    value: (row: any) => row["email"] || '',
                },
                {
                    label: "Status",
                    value: (row: any) => {
                        const {user} = extracted(row)
                        return user ? AccountStatusArr[user.inviteStatus || 0] : "Pending";
                    },
                },
                {
                    label: "Offer Type",
                    value: (row: any) => {
                        const {offerType} =  extracted(row)
                        return offerType;
                    },
                },
                {
                    label: "Participant Contribution",
                    value: (row: any) => {
                        const {participantContribution} =   extracted(row)
                        return participantContribution;
                    },
                },
                {
                    label: "Combined Contribution",
                    value: (row: any) => {
                        const {contributionAmount} =   extracted(row)
                        return contributionAmount;
                    },
                },
                {
                    label: "Employer Contribution",
                    value: (row: any) => {
                        const {employerContribution} =   extracted(row)
                        return employerContribution;
                    },
                },
                {
                    label: "Death Benefit",
                    value: (row: any) => {
                        const {deathBenefit} =   extracted(row)
                        return deathBenefit;
                    },
                },
                {
                    label: "Premiumn",
                    value: (row: any) => {
                        const {annualPremium} =   extracted(row)
                        return annualPremium;
                    },
                },
                {
                    label: "Current Tranche",
                    value: (row: any) => {
                        const {trancheNumber} =   extracted(row)
                        return trancheNumber;
                    },
                },
            ];
        case "trancheManagementReview":
         
            return [
                {
                    label: "Case Processor",
                    value: (row: any) => row["caseProcessor"] || '',
                },
                {
                    label: "App Type",
                    value: (row: any) => row["appType"] || '',
                },
                {
                    label: "Insured",
                    value: (row: any) => row["clientName"]
                        ? `=HYPERLINK("${SITE_URL}new-client/detail/${row["clientId"]}", "${row["clientName"]}")`
                        : '',
                },
                {
                    label: "Policy #",
                    value: (row: any) => row["policyNumber"] || '',
                },
                {
                    label: "Policy Status",
                    value: (row: any) => row["processingStatus"] || '',
                },
                {
                    label: "Renewal Status",
                    value: (row: any) => row["renewalStatus"] || '',
                },
                {
                    label: "Growth %",
                    value: (row: any) => row["growthPercent"] || '',
                },
                {
                    label: "Original Estimated Cash Value (Discounted)",
                    value: (row: any) => row["originalEstimatedCashValue"] || '',
                },
                {
                    label: "Current Actual Cash Value (Discounted)",
                    value: (row: any) => row["currentActualCashValue"] || '',
                },
                {
                    label: "Current Actual Loan Amount",
                    value: (row: any) => row["currentActualLoanAmount"] || '',
                },
                {
                    label: "Original Estimated Loan Amount",
                    value: (row: any) => row["originalEstimatedLoanAmount"] || '',
                },
                {
                    label: "Contribution Frequency",
                    value: (row: any) => row["contributionFrequency"] || '',
                },
                {
                    label: "Allocations and %",
                    value: (row: any) => row["allocationsPercent"] || '',
                },
                {
                    label: "Loan to Value %",
                    value: (row: any) => row["loanToValuePercent"] || '',
                },
                {
                    label: "Bank Interest Rates",
                    value: (row: any) => row["bankInterestRates"] || '',
                },
                {
                    label: "Carrier",
                    value: (row: any) => row["carrier"] || '',
                },
                {
                    label: "ID Docs",
                    value: (row: any) => row["idDocs"] || '',
                },
                {
                    label: "Surrender Date",
                    value: (row: any) => row["surrenderDate"] || '',
                },
                {
                    label: "Notes",
                    value: (row: any) => (row: any) => row["Notes"] || '',
                },
            ]; 
          case "trancheManagementPayment":
         
            return [
                 {
                    label: "Case Processor",
                    value: (row: any) => row["caseProcessor"] || '',
                },
                {
                    label: "App Type",
                    value: (row: any) => row["appType"] || '',
                },
                {
                    label: "Insured",
                    value: (row: any) => row["clientName"]
                       ? `=HYPERLINK("${SITE_URL}new-client/detail/${row["clientId"]}", "${row["clientName"]}")`
                       : '',
                },
                {
                    label: "Policy #",
                    value: (row: any) => row["policyNumber"] || '',
                },
                {
                    label: "Agent",
                    value: (row: any) => row["agentName"] || '',
                },
                {
                    label: "Region",
                    value: (row: any) => row["region"] || '',
                },
                {
                    label: "Case Manager",
                    value: (row: any) => row["caseManager"] || '',
                },
                {
                    label: "Policy Status",
                    value: (row: any) => row["processingStatus"] || '',
                },
                {
                    label: "Renewal Status",
                    value: (row: any) => row["renewalStatus"] || '',
                },
                {
                    label: "Contribution Year",
                    value: (row: any) => row["contributionYear"] || '',
                },
                {
                    label: "Add Contribution",
                    value: (row: any) => row["addContribution"] || '',
                },
                {
                    label: "Contribution Type",
                    value: (row: any) => row["contributionType"] || '',
                },
                {
                    label: "Contribution Frequency",
                    value: (row: any) => row["contributionFrequency"] || '',
                },
                {
                    label: "Contribution Owed",
                    value: (row: any) => row["contributionOwed"] || '',
                },
                {
                    label: "Contribution Received",
                    value: (row: any) => row["contributionReceived"] || '',
                },
                {
                    label: "Next Contribution Deadline",
                    value: (row: any) => row["contributionNextDeadline"] || '',
                },
                {
                    label: "Loan to Value %",
                    value: (row: any) => row["loanToValuePercent"] || '',
                },
                {
                    label: "Carrier",
                    value: (row: any) => row["carrier"] || '',
                },
                {
                    label: "ID Docs",
                    value: (row: any) => row["idDocs"] || '',
                },
                {
                    label: "Surrender Date",
                    value: (row: any) => row["surrenderDate"] || '',
                },
                {
                    label: "Notes",
                    value: (row: any) => (row: any) => row["Notes"] || '',
                }, 
                   
            ];
        case "trancheRate":
         
            return [
                {
                    label: "Policy Year",
                    value: (row: any) => row["policyYear"] || '',
                },
                {
                    label: "Status",
                    value: (row: any) => row["status"] || '',
                },
                {
                    label: "Finance Platform",
                    value: (row: any) => row["loanType"] || '',
                },
                {
                    label: "Finance Platform Rate",
                    value: (row: any) => row["loanRate"] || '',
                },
                {
                    label: "Market Rate Adjustment",
                    value: (row: any) => row["mrAdjustment"] || '',
                },
                {
                    label: "Enter Bank Margin Rate",
                    value: (row: any) => row["bankMarginRate"] || '',
                },
                {
                    label: "Total Rate",
                    value: (row: any) => row["rate"] || '',
                },
                {
                    label: "Interest Start Date",
                    value: (row: any) => row["interestStartDate"]? moment(row["interestStartDate"]).format('MM-DD-YYYY'): '',
                },
                {
                    label: "Interest End Date",
                    value: (row: any) => row["interestEndDate"]? moment(row["interestEndDate"]).format('MM-DD-YYYY'): '',
                },
                {
                    label: "Total Loan Balance",
                    value: (row: any) => row["totalLoanBalance"] || '',
                },
            ];     
        default:
            return []
    }

}


function append(source:any[], destinatiom: any[] ){
    destinatiom.forEach((element) =>{
        source.push(element)
    })
}

